interface BannerActionsProps {
  children: React.ReactNode;
}

const BannerActions = ({ children }: BannerActionsProps) => {
  return <div className='flex items-center gap-2.5 self-end'>{children}</div>;
};

export default BannerActions;
